module.exports = __webpack_public_path__ + "resources/img/cancel@3x.e5a3b9f6.png";